// extracted by mini-css-extract-plugin
module.exports = {"noDisplay":"CompanyHeader_noDisplay__300QK","pdfHeader":"CompanyHeader_pdfHeader__1c3G6"};